<template>
	<div></div>
</template>

<script>
	
	import { watch, onMounted, ref } from 'vue';
	import { useForm, usePage } from '@inertiajs/inertia-vue3';

	export default {
		props:{
			errors : Object,
			flash : Object,
		},
		setup(props) {

			const formJoinCommunity = useForm({
				community_uuid 		: null,
				community_name 		: null,
				community_status 	: null,
				processing 	  		: false,
			});

			const formVotePost = useForm({
				community_uuid 	: null,
				post_uuid 		: null,
				vote_label  	: '',
				prev_vote  		: 0,
				vote  			: 0,
				cache			: ''
			});

			const joinCommunity = (_comm,callback)=>{
				formJoinCommunity.community_uuid 	= _comm.community_uuid;
				formJoinCommunity.community_name 	= _comm.community_name;
				formJoinCommunity.community_status 	= _comm.community_status;

				formJoinCommunity.post(route('member.community.community-join'), {
									preserveState: false,
									preserveScroll: true,
									onSuccess:()=>{
										formJoinCommunity.reset();
										callback(true);
									}
								})
					
			}


			const votePost = (_community_uuid,_com_name,_post_uuid,_vote_label,_val,_index,_cache_vote,callback)=>{
				let entry = {};

				formVotePost.community_uuid 	= _community_uuid;
				formVotePost.post_uuid 			= _post_uuid;
				formVotePost.vote_label 		= _vote_label;
				formVotePost.prev_vote 			= _val;
				formVotePost.cache 				= _cache_vote;
				
				if(_vote_label=='like')
				{
					formVotePost.vote 		= 1;
				}else{
					formVotePost.vote 		= -1;
				}
				
				if((_val==1 && _vote_label=='like') || (_val==-1 && _vote_label=='dislike'))
				{
					formVotePost.vote 		= 0;
				}

				// entry.result 	= 'failed';
				// entry.data 		= null;

				formVotePost.post(route('member.community.post-vote',{community_name:_com_name,post_uuid:_post_uuid}), {
								preserveState: true,
								preserveScroll: true,
								only: ['flash','errors'],
								onSuccess:()=>{
									let flash = props.flash.toast;
									
									if(flash.type=="success"){

										// entry.result 	= 'success';
										// entry.data 		= {
										// 	vote 		: formVotePost.vote,
										// 	vote_total 	: flash.data['vote_total'],
										// 	vote_weight : flash.data['vote_weight'],
										// 	vote_weight : flash.data['vote_weight'],
										// };

										callback(true);

										formVotePost.reset();
									}else{
										callback(false);
									}
								}
							})

			}

			return{
				formVotePost,
				formJoinCommunity,
				joinCommunity,
				votePost
			}
		}
	}
</script>